import apiClient from '../client.js'

async function getTicketAccountSettings(params) {
  const response = await apiClient.get('/ticket-account/settings', { params })
  return response.data.settings
}

class TicketAccountService {
  get = {
    /**
     * Load ticket settings for the account scope.
     *
     * @param {{ accountId?: string }} [params] Query params — `accountId`
     *   targets another account when fetching cross-account settings in
     *   group mode. Omit for the session's current account.
     * @returns {Promise<object>} Unwrapped from `response.data.settings`.
     */
    async settings(params) {
      return getTicketAccountSettings(params)
    },
  }
}

export default new TicketAccountService()
